import { Stack, Typography } from '@mui/material';
import { POSITION_SLOT_WORKER_TYPE_LABELS, POSITION_SLOT_WORKER_TYPE } from 'domain/shared/positionSlot';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import { POSITION_SLOT_WORKER_TYPE_EXCEPTION_TOOLTIP } from '../../constants';
import { PreviewPositionSlotListItem } from '../../types';
import { Tooltip } from 'framework/ui/mui-builder';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const renderCategory = ({ positionSlot }: { positionSlot: PreviewPositionSlotListItem }) => {
  const label = positionSlot.workerType
    ? POSITION_SLOT_WORKER_TYPE_LABELS[positionSlot.workerType] || positionSlot.workerType
    : EMPTY_VALUE_INDICATOR;

  if (positionSlot.workerType !== POSITION_SLOT_WORKER_TYPE.EXCEPTION) return label;

  return (
    <Stack direction="row" alignItems="center" spacing={0.5} sx={{ display: 'inline-flex' }}>
      <Typography>{label}</Typography>
      <Tooltip title={POSITION_SLOT_WORKER_TYPE_EXCEPTION_TOOLTIP}>
        <WarningAmberIcon sx={{ fontSize: 18, color: 'warning.main', verticalAlign: 'middle' }} />
      </Tooltip>
    </Stack>
  );
};

export default renderCategory;
